<div>
    <h1>Referee Panel</h1>
    <mat-form-field>
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" (click)="picker.open()" (dateChange)="changeDate($event)" [value]="selectedDate">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker [dateClass]="setDateClass()" #picker></mat-datepicker>
    </mat-form-field>
    <mat-tab-group dynamicHeight>
            <mat-tab *ngFor="let match of matches" [label]="match.title">
                <table class="match-info">
                    <tr>
                        <td>{{ match.teamA.tricode }}<img [src]="match.teamA?.logo || placeholderTeamLogo"></td>
                        <td>vs</td>
                        <td><img [src]="match.teamB?.logo || placeholderTeamLogo">{{ match.teamB.tricode }}</td>
                    </tr>
                </table>
                <table class="staff-list">
                    <tr>
                        <td>Coach</td>
                        <td>AC</td>
                        <td>AC</td>
                        <td>Coach</td>
                    </tr>
                    <tr>
                        <td><img [src]="match.teamA?.coachPicture || placeholderPersonImage"></td>
                        <td><img [src]="match.teamA?.asscoachPicture || placeholderPersonImage"></td>
                        <td><img [src]="match.teamB?.asscoachPicture || placeholderPersonImage"></td>
                        <td><img [src]="match.teamB?.coachPicture || placeholderPersonImage"></td>
                    </tr>
                    <tr>
                        <td>{{ match.teamA.coach }}</td>
                        <td>{{ match.teamA.asscoach }}</td>
                        <td>{{ match.teamB.asscoach }}</td>
                        <td>{{ match.teamB.coach }}</td>
                    </tr>
                </table>
                <mat-divider></mat-divider>
                <table class="player-list">
                    <ng-container *ngFor="let pos of [1,2,3,4,5]">
                        <ng-container *ngIf="getPlayerFromTeamByPosition(match.teamAPlayer, pos) as playerA">
                            <ng-container *ngIf="getPlayerFromTeamByPosition(match.teamBPlayer, pos) as playerB">
                                <tr>
                                    <td></td>
                                    <td>
                                        A{{pos}}
                                        <br>
                                        <img class="country-flag" [src]="nationalFlagUrl + playerA.nationality + '.svg'" >{{ playerA.name }}
                                    </td>
                                    <td>
                                        B{{pos}}
                                        <br>
                                        <img class="country-flag" [src]="nationalFlagUrl + playerB.nationality + '.svg'" >{{ playerB.name }}
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>
                                        <img class="info-img-on"  *ngIf="playerA.armrest == true" [src]="armrestOnImage">
                                        <img class="info-img-off" *ngIf="playerA.armrest != true" [src]="armrestOffImage">
                                        <img class="info-img-on"  *ngIf="playerA.pillow == true" [src]="pillowOnImage">
                                        <img class="info-img-off" *ngIf="playerA.pillow != true" [src]="pillowOffImage">
                                        <img class="info-img-on"  *ngIf="playerA.inears == true" [src]="inearsOnImage">
                                        <img class="info-img-off" *ngIf="playerA.inears != true" [src]="inearsOffImage">
                                    </td>
                                    <td>
                                        <img [src]="playerA.picture || placeholderPersonImage">
                                    </td>
                                    <td>
                                        <img [src]="playerB.picture || placeholderPersonImage">
                                    </td>
                                    <td>
                                        <img class="info-img-on"  *ngIf="playerB.armrest == true" [src]="armrestOnImage">
                                        <img class="info-img-off" *ngIf="playerB.armrest != true" [src]="armrestOffImage">
                                        <img class="info-img-on"  *ngIf="playerB.pillow == true" [src]="pillowOnImage">
                                        <img class="info-img-off" *ngIf="playerB.pillow != true" [src]="pillowOffImage">
                                        <img class="info-img-on"  *ngIf="playerB.inears == true" [src]="inearsOnImage">
                                        <img class="info-img-off" *ngIf="playerB.inears != true" [src]="inearsOffImage">
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td><mat-icon>mic</mat-icon>{{ getPlayerFromTeamByPosition(match.teamAPlayer, pos)?.languages }}</td>
                                    <td><mat-icon>mic</mat-icon>{{ getPlayerFromTeamByPosition(match.teamBPlayer, pos)?.languages }}</td>
                                    <td></td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </table>
            </mat-tab>
    </mat-tab-group>
</div>